import React from 'react';
import { useSelector } from 'react-redux';
import { DECISION_NODE_INFO_WIDGETS } from '../../../constants/decisionTree';
import { getDecisionNodeAtPath } from '../../../extractFromState';
import DTRevolveOrderInfoWidget from './Revolve/DTRevolveOrderInfoWidget/DTRevolveOrderInfoWidget';
import DTRevolveCancelOrderInfoWidget from './Revolve/DTRevolveCancelOrderInfoWidget/DTRevolveCancelOrderInfoWidget';
import DTRbiGiftCardInfoWidget from './RBI/DTRbiGiftCardInfoWidget/DTRbiGiftCardInfoWidget';
import DTPreviousRefundsWidget from './DTPreviousRefundsWidget/DTPreviousRefundsWidget';
import DTPointsInfoWidget from './RBI/DTPointsInfoWidget/DTPointsInfoWidget';
import DTTicketFieldsWidget from './DTTicketFieldsWidget/DTTicketFieldsWidget';
import DTRbiRutrEventsInfoWidget from './RBI/DTRbiRutrEventsInfoWidget/DTRbiRutrEventsInfoWidget';
import DTRbiCouponInfoWidget from './RBI/DTRbiCouponInfoWidget/DTRbiCouponInfoWidget';
import DTRbiRefundInfoWidget from './RBI/DTRbiRefundInfoWidget/DTRbiRefundInfoWidget';
import DTRbiRefundedOrderInfoWidget from './RBI/DTRbiRefundedOrderInfoWidget/DTRbiRefundedOrderInfoWidget';
import DTRbiSelectedStoreDetailsWidget from './RBI/DTRbiSelectedStoreDetailsWidget/DTRbiSelectedStoreDetailsWidget';
import DTSubscriptionDetailsWidget from './DTSubscriptionDetailsWidget/DTSubscriptionDetailsWidget';
import DTOrderStatusLineItemDetailsWidget from './DTOrderStatusLineItemDetailsWidget/DTOrderStatusLineItemDetailsWidget';
import DTAmazonOrderDetailsWidget from './DTAmazonOrderDetailsWidget/DTAmazonOrderDetailsWidget';
import DTReturnPortalDetailsWidget from './DTReturnPortalDetailsWidget/DTReturnPortalDetailsWidget';
import DTToBeRefundedItemDetailsWidget from './DTToBeRefundedItemDetailsWidget/DTToBeRefundedItemDetailsWidget';
import DTItemsForPartialRefundWidget from './DTItemsForPartialRefundWidget/DTItemsForPartialRefundWidget';
import DTCanceledItemDetailsWidget from './DTCanceledItemDetailsWidget/DTCanceledItemDetailsWidget';
import DTCancelAndRefundWidget from './DTCancelAndRefundWidget/DTCancelAndRefundWidget';
import DTSalesforceOrderDetailsWidget from './DTSalesforceOrderDetailsWidget/DTSalesforceOrderDetailsWidget';
import DTCustomInfoWidget from './DTCustomInfoWidget/DTCustomInfoWidget';
import DTOrderAddressInfoWidget from './DTOrderAddressInfoWidget/DTOrderAddressInfoWidget';
import DTRbiOffersInfoWidget from './RBI/DTRbiOffersInfoWidget/DTRbiOffersInfoWidget';
import DTRbiRemediationsWidget from './RBI/DTRbiRemediationsWidget/DTRbiRemediationsWidget';
import DTReplaceItemAndCustomerDetailsWidget from './DTReplaceItemAndCustomerDetailsWidget/DTReplaceItemAndCustomerDetailsWidget';
import DTCustomerProfileNotesWidget from './DTCustomerProfileNotesWidget/DTCustomerProfileNotesWidget';
import DTRbiHockeyChallengeWidget from './RBI/DTRbiHockeyChallengeWidget/DTRbiHockeyChallengeWidget';
import DTRbiChallengeWidget from './RBI/DTRbiChallengeWidget/DTRbiChallengeWidget';

const DTInfoWidget = () => {
  const decisionNode = useSelector(getDecisionNodeAtPath);

  switch (decisionNode && decisionNode.infoWidget) {
    case DECISION_NODE_INFO_WIDGETS.RBI_RUTR_EVENTS_INFO:
      return <DTRbiRutrEventsInfoWidget />;
    case DECISION_NODE_INFO_WIDGETS.RBI_POINTS_INFO:
      return <DTPointsInfoWidget />;
    case DECISION_NODE_INFO_WIDGETS.RBI_COUPON_INFO:
      return <DTRbiCouponInfoWidget />;
    case DECISION_NODE_INFO_WIDGETS.RBI_ORDER_REFUND_INFO:
      return <DTRbiRefundInfoWidget />;
    case DECISION_NODE_INFO_WIDGETS.RBI_GIFT_CARD_INFO:
      return <DTRbiGiftCardInfoWidget />;
    case DECISION_NODE_INFO_WIDGETS.RBI_REFUNDED_ORDER_INFO:
      return <DTRbiRefundedOrderInfoWidget />;
    case DECISION_NODE_INFO_WIDGETS.RBI_OFFERS_INFO:
      return <DTRbiOffersInfoWidget />;
    case DECISION_NODE_INFO_WIDGETS.RBI_SELECTED_STORE_DETAILS:
      return <DTRbiSelectedStoreDetailsWidget />;
    case DECISION_NODE_INFO_WIDGETS.SUBSCRIPTION_DETAILS:
      return <DTSubscriptionDetailsWidget />;
    case DECISION_NODE_INFO_WIDGETS.ORDER_STATUS_LINE_ITEM_DETAILS:
      return <DTOrderStatusLineItemDetailsWidget />;
    case DECISION_NODE_INFO_WIDGETS.RETURNED_ITEM_DETAILS:
      return <DTToBeRefundedItemDetailsWidget />;
    case DECISION_NODE_INFO_WIDGETS.PARTIAL_REFUND_ITEM_DETAILS:
      return <DTItemsForPartialRefundWidget />;
    case DECISION_NODE_INFO_WIDGETS.CANCELED_ITEM_DETAILS:
      return <DTCanceledItemDetailsWidget />;
    case DECISION_NODE_INFO_WIDGETS.CANCEL_AND_REFUND_INFO:
      return <DTCancelAndRefundWidget />;
    case DECISION_NODE_INFO_WIDGETS.PREVIOUS_REFUNDS:
      return <DTPreviousRefundsWidget />;
    case DECISION_NODE_INFO_WIDGETS.AMAZON_ORDER_INFO:
      return <DTAmazonOrderDetailsWidget />;
    case DECISION_NODE_INFO_WIDGETS.RETURN_PORTAL_INFO: // used in Steve Madden return portal flow
      return <DTReturnPortalDetailsWidget />;
    case DECISION_NODE_INFO_WIDGETS.CUSTOM_WIDGET:
      // renders widget with specified fields
      return <DTCustomInfoWidget />;
    case DECISION_NODE_INFO_WIDGETS.SALESFORCE_ORDER_INFO:
      return <DTSalesforceOrderDetailsWidget />;
    case DECISION_NODE_INFO_WIDGETS.REVOLVE_ORDER_DETAILS:
      return <DTRevolveOrderInfoWidget />;
    case DECISION_NODE_INFO_WIDGETS.REVOLVE_CANCEL_ORDER_INFO:
      return <DTRevolveCancelOrderInfoWidget />;
    case DECISION_NODE_INFO_WIDGETS.TICKET_FIELDS_WIDGET:
      return <DTTicketFieldsWidget />;
    case DECISION_NODE_INFO_WIDGETS.ORDER_ADDRESS_INFO_WIDGET:
      return <DTOrderAddressInfoWidget />;
    case DECISION_NODE_INFO_WIDGETS.RBI_REMEDIATIONS_WIDGET:
      return <DTRbiRemediationsWidget />;
    case DECISION_NODE_INFO_WIDGETS.CUSTOMER_DETAILS_FOR_ITEM_REPLACEMENT_WIDGET:
      return <DTReplaceItemAndCustomerDetailsWidget />;
    case DECISION_NODE_INFO_WIDGETS.CUSTOMER_PROFILE_NOTES_WIDGET:
      return <DTCustomerProfileNotesWidget />;
    case DECISION_NODE_INFO_WIDGETS.HOCKEY_CHALLENGE_WIDGET:
      return <DTRbiHockeyChallengeWidget />;
    case DECISION_NODE_INFO_WIDGETS.RBI_CHALLENGE_WIDGET:
      return <DTRbiChallengeWidget />;
    default:
      return null;
  }
};

export default DTInfoWidget;
